var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#414146",
  d: "M24 22a10 10 0 1 0-10-10 10.013 10.013 0 0 0 10 10Zm0-16a6 6 0 1 1 0 12 6 6 0 0 1 0-12ZM6 44a18 18 0 1 1 36 0 2 2 0 0 1-4 0 14 14 0 0 0-28 0 2 2 0 0 1-4 0Z"
})));
export { SvgUser as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMGRhNzM2MTdjYWQ1OTcxNzdmMzJlODgxMWFhODA5ZmEuc3ZnIjs=";